import { facadesApi, facadesUrl } from "@/store/services/facades";
import { FacadesBatchPostRequest, FacadesBatchPostResponse } from "@/store/services/facades/types";

/** Severities API path on facades. */
const SEVERITIES_PATH = "severities";

const HEADERS = {
  Authorization: `Basic ${process.env.NEXT_PUBLIC_FACADES_ABCDE_API_KEY}`,
};

export const severitiesFacadesApi = facadesApi.injectEndpoints({
  endpoints: (build) => ({
    // A mutation, so a retried batch is always re-sent rather than read from cache.
    postSeveritiesBatch: build.mutation<FacadesBatchPostResponse, FacadesBatchPostRequest>({
      query: ({ priority, batch }) => ({
        method: "POST",
        url: `${SEVERITIES_PATH}/batch`,
        headers: {
          ...HEADERS,
          "Content-Type": "application/x-ndjson",
        },
        params: { priority },
        body: batch.join("\n"),
      }),
      // Callers retry with dispatchWithRetries.
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/** Opens the progress stream for these item ids. The API ends it once every item has completed or errored. */
export const streamSeveritiesProgress = async (itemIds: string[], signal?: AbortSignal) => {
  const response = await fetch(`${facadesUrl}${SEVERITIES_PATH}/progress`, {
    method: "POST",
    headers: { ...HEADERS, "Content-Type": "application/json" },
    body: JSON.stringify(itemIds),
    signal,
  });

  if (!response.ok || !response.body) throw new Error(`Severities progress request failed: ${response.status}`);

  return response.body;
};

/** Fetches results for these item ids: one line per item, holding its `result` or `error`. */
export const fetchSeveritiesResults = async (itemIds: string[], stamps: string[]) => {
  const url = new URL(`${facadesUrl}${SEVERITIES_PATH}/results`);
  stamps.forEach((stamp) => url.searchParams.append("stamps", stamp));

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: { ...HEADERS, "Content-Type": "application/json" },
    body: JSON.stringify(itemIds),
  });

  if (!response.ok) throw new Error(`Severities results request failed: ${response.status}`);

  return response.text();
};
